import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlarmClock, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { StatusBadge, LeagueChip } from "@/components/badges";

export default function PreGameWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => { try { const r = await api.get("/pregame"); setData(r.data); } catch { /* pregame poll failed; keep last data */ } };
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="bg-[#0F1420] border border-[#232D42] rounded-xl p-5" data-testid="pregame-widget">
      <div className="flex items-center gap-2 mb-1">
        <AlarmClock size={16} className="text-[#FF4D4D]" />
        <h3 className="font-heading font-semibold text-slate-100">Pre-Game Late Window</h3>
      </div>
      <p className="text-xs text-slate-500 mb-4">Most line movement lands 30–60 min before tip. <span className="text-[#FFB020]">Questionable</span> is the status to watch.</p>

      {!data ? (
        <div className="text-sm text-slate-500 font-mono">Loading…</div>
      ) : data.late_window.length === 0 && data.upcoming.length === 0 ? (
        <div className="text-sm text-slate-500">No at-risk players with games in the next 6 hours.</div>
      ) : (
        <div className="space-y-3">
          {data.late_window.length > 0 && (
            <div>
              <div className="flex items-center gap-1.5 mb-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#FF4D4D] sq-pulse" />
                <span className="text-[11px] font-mono uppercase tracking-wider text-[#FF7A7A]">Late Window · ≤60 min</span>
              </div>
              <div className="space-y-2">
                {data.late_window.slice(0, 6).map((p) => (
                  <Link key={p.id} to={`/players/${p.id}`} data-testid={`pregame-late-${p.id}`}
                    className="flex items-center justify-between gap-2 rounded-lg border border-[#FF4D4D]/25 bg-[#FF4D4D]/8 px-3 py-2 hover:bg-[#FF4D4D]/14 transition-colors">
                    <div className="min-w-0">
                      <div className="flex items-center gap-1.5">
                        <LeagueChip league={p.league} />
                        <span className="text-sm font-medium text-slate-100 truncate">{p.name}</span>
                      </div>
                      <span className="text-[11px] text-slate-500 font-mono">{p.team_abbr} {p.opponent}</span>
                    </div>
                    <div className="text-right shrink-0">
                      <StatusBadge status={p.status} />
                      <div className="text-[11px] font-mono text-[#FF7A7A] mt-0.5 flex items-center gap-1 justify-end"><Clock size={10} />{p.minutes_to_kickoff}m</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
          {data.upcoming.length > 0 && (
            <div className="pt-1">
              <span className="text-[11px] font-mono uppercase tracking-wider text-slate-500">Upcoming · at-risk</span>
              <div className="mt-2 space-y-1.5">
                {data.upcoming.slice(0, 4).map((p) => (
                  <Link key={p.id} to={`/players/${p.id}`} className="flex items-center justify-between text-sm hover:text-slate-100">
                    <span className="text-slate-300 truncate">{p.name} <span className="text-slate-600 font-mono text-xs">{p.team_abbr}</span></span>
                    <span className="font-mono text-xs text-slate-500">{Math.floor(p.minutes_to_kickoff / 60)}h {p.minutes_to_kickoff % 60}m</span>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
